import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class WeekCalculatorService {

  constructor() { }

  calcWeekNumber(dateIsoFormat: string) {
    const date = DateTime.fromISO(dateIsoFormat)
    const now = DateTime.now()
    const weekNumber = now.diff(date, 'weeks').toObject().weeks
    return Math.round(weekNumber) + 1
  }

}
